import { createSlice, current } from "@reduxjs/toolkit";


const initialState = {
    data: {
        goalsdata: [],
    },
    loading: false,
    error: null,
};

const goalsSlice = createSlice({
    name: 'goals',
    initialState,
    reducers: {

        // Loading .... 

        start(state) {
            state.loading = true;
            state.error = null;
        },
        failure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },

        // Goals store ...... 

        getGoalsSuccess(state, action) {
            state.loading = false;
            state.data.goalsdata = action.payload;
        },

        deleteGoal(state, action) {
            state.loading = false;
            const filteredData = state.data.goalsdata.filter(e => e.id !== action.payload);
            state.data.goalsdata = filteredData;
        }
    },
});

export default goalsSlice.reducer;
export const {
    start,
    failure,
    getGoalsSuccess,
    deleteGoal } = goalsSlice.actions;